import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function ReferralRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract referral email from the query parameter
    const searchParams = new URLSearchParams(location.search);
    const referrerEmail = searchParams.get('ref');

    // Redirect to the waitlist form and include the referrer email
    if (referrerEmail) {
      navigate(`/?ref=${referrerEmail}`, { replace: true });
    } else {
      navigate('/', { replace: true });  // Fallback to the waitlist form without referrer
    }
  }, [location, navigate]);

  return null;  // No UI needed, it simply redirects
}

export default ReferralRedirect;
